import React from "react";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import HeaderStyled from "./Header.styled";
import Menu from "../Menu";
import { Link } from "react-router-dom";

const Header = ({
  title,
  onFirstPage,
  prevPage,
  levelID,
  pageID,
  link,
  backgroundColor,
  style,
}) => {
  return (
    <HeaderStyled backgroundColor={backgroundColor} style={style}>
      {prevPage && (
        <Link
          to={link || (onFirstPage ? "/menu" : prevPage)}
          className={!levelID ? "disabled" : ""}
        >
          <button tabIndex="1">
            <FontAwesomeIcon icon={faChevronLeft} size="2x" />
          </button>
        </Link>
      )}
      {title && <FormattedMessage id={title} />}

      <Menu />
    </HeaderStyled>
  );
};
export default Header;
